import React from 'react'
import EventDashboard from './EventDashboard'
import SrpEventDashboard from './SRPEventDashboard'

export default EventDashboard
export { SrpEventDashboard }

// const ClientEventDashboard = ({ CLIENT }) => {
//   if (CLIENT === SRP_CLIENT) return <SrpEventDashboard />
//   else return <EventDashboard />
// }

// const mapStateToProps = state => ({
//   CLIENT: getClientInfo(state),
// })

// export default connect(mapStateToProps)(ClientEventDashboard)
